import { LicenseInfo } from "@mui/x-license";

export function initMuiX() {
  // key is inline as recommended by mui.
  // see https://mui.com/x/introduction/licensing/#license-key-security
  LicenseInfo.setLicenseKey(
    "1ef7de6a79b7c02eb57d43273df4c683Tz0xMzE4NjQsRT0xODIwNzA3MTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MyxBVD1zaW5nbGUsS1Y9Mg==",
  );
}
